import { SERVER_URL } from 'src/constants';

export const Image = (link: string) => (index: number) => `
    <mj-image src="${SERVER_URL}${link}" alt="image_tag"
    padding="0" padding-bottom="6px" padding-top="6px" border-radius="5px" fluid-on-mobile="true" />
`;

// removed from image height="172.5px"
